export class SingleRedoFileResponse{
    samplesUpdated: boolean;
    message: string;
    confirmationSamplesList: Array<SingleRedoSampleObject>;
}

export class SingleRedoMultiPlateRequestDTO{
    labID: string;
    confirmationSamplesList: Array<SingleRedoSampleObject>;
    ignoreReRunCount: boolean;
}

export class SingleRedoSampleObject{
    _id: any;
    sampleID: string;
    plateID: string;
    position: string;
    reRunCount: number;
}